import { LoaderFunctionArgs, redirect } from 'react-router-dom'
import { FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { toast } from 'react-toastify'

import { registrationApi } from '../../../services/registration'
import i18n from '../../../i18n'
import { ParticipantStatus } from '../../../types'
import type { AppStore } from '../../../store'
import type { RegisterParams } from '../../../services/registration'

export const registerEvent =
  (store: AppStore) =>
  async ({ request }: LoaderFunctionArgs) => {
    const data = (await request.json()) as RegisterParams
    const { t } = i18n

    const result = await store.dispatch(registrationApi.endpoints.register.initiate(data))

    if ('error' in result && result.error) {
      if ((result.error as FetchBaseQueryError).data === 'user is already registered') {
        toast.info(t('Vous êtes déjà inscrit à cet événement'))
        return redirect(`/events/${data.event_id}`)
      }
      toast.error(t("Erreur lors de l'inscription à l'événement"))
      return result
    }

    if ('data' in result && result.data) {
      switch (result.data.status) {
        case ParticipantStatus.PendingCheckout:
          return redirect(result.data.checkout_url)
        case ParticipantStatus.Confirmed:
          toast.success(t('Inscription confirmée'))
          return redirect(`/events/${data.event_id}`)
        case ParticipantStatus.PendingPartner:
          toast.info(t('Inscription en attente de validation'))
          return redirect(`/events/${data.event_id}`)
        case ParticipantStatus.Cancelled:
          toast.error(t('Inscription annulée'))
          break
        case ParticipantStatus.CheckoutFailed:
        default:
          toast.error(t("Erreur lors de l'inscription"))
          break
      }
    }

    return new Response(null, {
      status: 400,
      statusText: 'Failed to register event',
    })
  }
